// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__XrPSS","filter-list":"sidebar_filter-list__CfLHU"};